// AUTH API module (doc 12 §3). Pure typed functions over the http instance.
import { http } from '@/services/http'
import type { ApiResource } from '@/types/api'
import type {
  AuthResult,
  LoginCredentials,
  MeResult,
  RegisterPayload,
} from '@/types/auth'

export const authApi = {
  // POST /auth/login → { user, player, token, token_type }
  login: (credentials: LoginCredentials) =>
    http
      .post<ApiResource<AuthResult>>('/auth/login', credentials)
      .then((r) => r.data.data),

  // POST /auth/register → 201 { user, player, token, token_type }
  register: (payload: RegisterPayload) =>
    http
      .post<ApiResource<AuthResult>>('/auth/register', payload)
      .then((r) => r.data.data),

  // GET /auth/me → user + player + roles + permissions
  me: () =>
    http.get<ApiResource<MeResult>>('/auth/me').then((r) => r.data.data),

  // POST /auth/refresh → { token, token_type }
  refresh: () =>
    http
      .post<ApiResource<{ token: string; token_type: string }>>('/auth/refresh')
      .then((r) => r.data.data),

  // POST /auth/logout → 204
  logout: () => http.post<void>('/auth/logout').then(() => undefined),

  // POST /auth/forgot-password → 200 (generic message, no enumeration)
  forgotPassword: (email: string) =>
    http
      .post<ApiResource<null>>('/auth/forgot-password', { email })
      .then((r) => r.data),

  // POST /auth/reset-password → 200
  resetPassword: (payload: {
    email: string
    token: string
    password: string
    password_confirmation: string
  }) =>
    http
      .post<ApiResource<null>>('/auth/reset-password', payload)
      .then((r) => r.data),
}
